import { useEffect, useState } from 'react';
import { loadConn, saveConn, PAGES, type Conn, type PageId } from './conn';
import UsagePage from './pages/UsagePage';
import AgentsPage from './pages/AgentsPage';
import SkillsPage from './pages/SkillsPage';
import ContextPage from './pages/ContextPage';
import MonitoringPage from './pages/MonitoringPage';
import ModelsPage from './pages/ModelsPage';

export default function App() {
  const [conn, setConn] = useState<Conn>(loadConn());
  const [page, setPage] = useState<PageId>('agents');
  // Draft values for the base/key inputs — committed to `conn` on blur/Enter
  // so we don't fire API calls (and auto-provision namespaces) per keystroke.
  const [baseDraft, setBaseDraft] = useState(conn.baseUrl);
  const [keyDraft, setKeyDraft] = useState(conn.apiKey);
  useEffect(() => { saveConn(conn); }, [conn]);
  const upd = (p: Partial<Conn>) => setConn((c) => ({ ...c, ...p }));
  const commit = () => upd({ baseUrl: baseDraft.trim(), apiKey: keyDraft.trim() });

  return (
    <div className="layout">
      <main className="main">
        {page === 'usage' && <UsagePage conn={conn} />}
        {page === 'agents' && <AgentsPage conn={conn} />}
        {page === 'skills' && <SkillsPage conn={conn} />}
        {page === 'context' && <ContextPage conn={conn} />}
        {page === 'monitoring' && <MonitoringPage conn={conn} />}
        {page === 'models' && <ModelsPage conn={conn} onChange={upd} />}
      </main>

      <nav className="sidebar">
        <div className="brand">⬡ Agent&nbsp;Platform</div>
        <div className="nav">
          {PAGES.map((p) => (
            <button key={p.id} className={`nav-item ${page === p.id ? 'active' : ''}`} onClick={() => setPage(p.id)}>
              <span className="nav-ico">{p.icon}</span>{p.label}
            </button>
          ))}
        </div>
        <div className="conn">
          <div className="conn-title">Connection</div>
          <label>API base</label>
          <input value={baseDraft} onChange={(e) => setBaseDraft(e.target.value)}
            onBlur={commit} onKeyDown={(e) => { if (e.key === 'Enter') (e.target as HTMLInputElement).blur(); }} />
          <label>API key (your account)</label>
          <input type="password" value={keyDraft} placeholder="sk-srv-…  (Enter to connect)"
            onChange={(e) => setKeyDraft(e.target.value)} onBlur={commit}
            onKeyDown={(e) => { if (e.key === 'Enter') (e.target as HTMLInputElement).blur(); }} />
          <button style={{ width: '100%', marginTop: 8 }} onClick={commit}>Connect</button>
          <div className="conn-meta">{conn.apiKey ? '● connected key' : '○ no key'} · {conn.provider}{conn.model ? ` / ${conn.model}` : ''}</div>
        </div>
      </nav>
    </div>
  );
}
